/* RESPONSIBLE TEAM: team-standalone */

import { CHANNEL_SALESFORCE_CASE } from 'embercom/lib/operator/custom-bots/constants';
import { ChannelTargetingBodyData } from '../definitions';

export default class SalesforceChannelTargetingBodyData extends ChannelTargetingBodyData {
  get addMessengerChannel() {
    return true;
  }

  get channelGroupTitleKey() {
    return 'operator.workflows.channels.groupings.salesforce';
  }

  get channels() {
    return [
      {
        value: CHANNEL_SALESFORCE_CASE,
        icon: 'salesforce',
        requiresAppStoreInstallation: false,
        // eslint-disable-next-line @intercom/intercom/no-bare-strings
        channelTypeValue: 'Salesforce',
        isSetup: true,
      } as const,
    ];
  }
}
